<template>
	<div>
		<div v-if="hasUnhandledInvestors" class="table_hint_box">
			<RenderTextAsTemplate :text="unhandledInvestorsHint"/>
		</div>
		<div class="table_head">
			<div class="flex flex_between flex_1">
				<div>
					<md-button class="md-blank margin_r" @click="editSell">
						<i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
						{{ $t("seller.sell.SetSalesParameters") }}
					</md-button>
					<md-button class="md-blank margin_r" @click="showSmartBundleNoticeModal">
						<i class="fa fa-paperclip btn_icon" aria-hidden="true"></i>
						{{ $t("SellTable.smartBundle.invoices") }}
					</md-button>
					<md-button class="md-blank margin_r" @click="uploadReceivables">
						<i class="fa fa-upload btn_icon" aria-hidden="true"></i>
						{{ $t("seller.sell.uploadReceivables") }}
					</md-button>
				</div>
				<el-dropdown @command="(command) => command()">
					<md-button class="md-blank">
						{{ $t("common.allSelected") }}<i class="el-icon-arrow-down el-icon--right"></i>
					</md-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="clickSubmit">
							<i class="fa fa-paper-plane"></i> {{ $t("SellTable.button.startAuction") }}
						</el-dropdown-item>
						<el-dropdown-item :command="clickReset">
							<i class="fa fa-undo"></i> {{ $t("common.button.reset") }}
						</el-dropdown-item>
						<el-dropdown-item :command="bundle">
							<i class="fa fa-paperclip"></i> {{ $t("SellTable.Bundle.invoices") }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<SaleWithRetentionOptionConfirmModal v-if="retentionOptionModalShown"
											 :currency="currency"
											 :retention-check="retentionCheck"
											 @confirm="save"
											 @close="closeRetentionOptionModal"
		/>
	</div>
</template>
<script>

import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import RenderTextAsTemplate from "@/components/templates/common/RenderTextAsTemplate";
import SaleWithRetentionOptionConfirmModal from "./SaleWithRetentionOptionConfirmModal";
import {retentionCheckApi} from "@/common/api/retentionCheckApi";

export default {
	components: { RenderTextAsTemplate, SaleWithRetentionOptionConfirmModal },
	data() {
		return {
			retentionOptionModalShown: false,
			isSmartBundling: false,
			currency: null,
			retentionCheck: null,
		};
	},
	props: {
		pageType: { type: String, default: "upload" },
		hasUnhandledInvestors: { type: Boolean, default: false },
		gridApi: Object
	},
	computed: {
		unhandledInvestorsHint() {
			return this.$t("seller.sell.unhandledInvestors.hint", {
				investorsUrl: navigationUtils.getPathWithActiveTab(navigationPaths.seller.sell, navigationTabs.seller.sell.investors)
			})
		},
	},
	methods: {
		smartBundle() {
			this.isSmartBundling = true;

			// Amount and currency are undefined for smart bundling, so we simply assume EUR
			retentionCheckApi.checkRetention({ amount: Number.MAX_VALUE, currency: 'EUR' })
				.then(res => this.showRetentionOptionModal(res, 'EUR'))
				.catch(this.toast)
		},
        showSmartBundleNoticeModal() {
			let option = {
				title: this.$t('SellTable.smartBundle.invoices'),
				msg: this.$t('SellTable.smartBundle.notice'),
				confirmFun: this.smartBundle,
  				customClass: 'msg_box_title_bold msg_box_title_center msg_box_width_l'
			};
			this.confirmMeg(option, true);
        },
		bundle: function() {
			this.isSmartBundling = false;

			let isRetentionAlreadyAllowed = false;
			let sumAmount = 0;
			let currency = "";
			this.gridApi.getSelectedRows()
				.forEach(row => {
					if (Number(row.allowedRetentionRate) > 0) {
						isRetentionAlreadyAllowed = true;
					}
					sumAmount += row.amount;
					currency = row.currency;
				});

			retentionCheckApi.checkRetention({ amount: sumAmount, currency: currency })
				.then(res => {
					if (!res.isRetentionAllowed) {
						this.clickItem({ type: "bundle", isRetentionAllowed: false });
					} else {
						if (isRetentionAlreadyAllowed) {
							// no confirmation necessary if at least one receivable has retention
							this.clickItem({ type: "bundle", isRetentionAllowed: true });
						} else {
							this.showRetentionOptionModal(res, currency);
						}
					}
				})
				.catch(this.toast)
		},
		editSell() {
			this.clickItem({ type: "setData" });
		},
		uploadReceivables() {
			this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.upload, navigationTabs.seller.upload.upload));
		},
		clickSubmit() {
			this.clickItem({ type: "share" });
		},
		clickReset() {
			this.clickItem({ type: "del" });
		},
		clickItem(data) {
			let checkData = this.gridApi.getSelectedRows();
			if (data.type !== "setData" && data.type !== "bundle" && data.type !== "smartBundle" && checkData.length <= 0) {
				this.toast(this.$t("common.warning.needSelectRow"));
				return;
			}
			this.$emit("checHead", {
				checkData: checkData,
				type: data.type,
				isRetentionAllowed: data.isRetentionAllowed,
			});
		},
		showRetentionOptionModal(retentionCheck, currency) {
			this.currency = currency
			this.retentionCheck = retentionCheck;
			this.retentionOptionModalShown = true;
		},
		closeRetentionOptionModal() {
			this.retentionOptionModalShown = false;
		},
		save(isRetentionAllowed) {
			this.closeRetentionOptionModal();

			if (this.isSmartBundling) {
				this.clickItem({ type: "smartBundle", isRetentionAllowed: isRetentionAllowed });
			} else {
				this.clickItem({ type: "bundle", isRetentionAllowed: isRetentionAllowed });
			}
		}
	}
};
</script>